import React from "react";
import { ImageIcon, BoxIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";
type ImagePlaceholderProps = {
  src?: string;
  alt: string;
  label: string;
  hint?: string;
  icon?: BoxIcon;
  aspectClass?: string;
  size?: 'sm' | 'md' | 'lg';
  tone?: 'light' | 'dark';
  eager?: boolean;
  className?: string;
};

/** Muestra la imagen real si existe; si no, un espacio reservado con el nombre exacto del asset. */
export function ImagePlaceholder({
  src,
  alt,
  label,
  hint,
  icon: Icon = ImageIcon,
  aspectClass = 'aspect-[4/5]',
  size = 'md',
  tone = 'light',
  eager = false,
  className
}: ImagePlaceholderProps) {
  const radius = size === 'sm' ? 'rounded-xl' : 'rounded-[20px]';
  if (src) {
    return <img src={src} alt={alt} loading={eager ? 'eager' : 'lazy'} decoding="async" className={twMerge('w-full object-cover', aspectClass, radius, className)} data-id="element-248" data-mp="8dpj4ld60xp0" />;
  }
  const dark = tone === 'dark';
  return <div role="img" aria-label={`Espacio reservado: ${label}`} className={twMerge('flex w-full flex-col items-center justify-center border-2 border-dashed text-center', dark ? 'border-white/25 bg-white/[0.06]' : 'border-teal/30 bg-teal-soft/40', size === 'sm' ? 'gap-1 p-1' : 'gap-3 p-5', aspectClass, radius, className)} data-id="element-249" data-mp="3bvhf0aufa1sh">
      <span className={twMerge('flex items-center justify-center rounded-full', dark ? 'bg-white/10 text-white' : 'bg-white text-teal-dark shadow-soft', size === 'sm' ? 'h-6 w-6' : size === 'lg' ? 'h-14 w-14' : 'h-11 w-11')} data-id="element-250" data-mp="59wwq3ida5f7">
        <Icon aria-hidden="true" className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-5 w-5'} data-id="element-251" data-mp="3dn49yuwubnju" />
      </span>
      <span className={twMerge('font-mono font-semibold uppercase leading-tight tracking-wide', dark ? 'text-white/85' : 'text-teal-dark', size === 'sm' ? 'text-[9px] sm:text-[10px]' : 'max-w-[18rem] text-[11px] sm:text-xs')} data-id="element-252" data-mp="3ilxlwiwhb6hw">
        {label}
      </span>
      {hint && size !== 'sm' && <span className={twMerge('max-w-[18rem] text-xs', dark ? 'text-white/65' : 'text-navy-soft')} data-id="element-253" data-mp="12vcgmxmm3kg2">{hint}</span>}
    </div>;
}